import React, { useState } from "react";
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  Container,
  Table,
  Modal,
} from "react-bootstrap";
import Swal from "sweetalert2";

import UtiPanCardService from "../../../services/UtiPanCardService";
import SideBar from "../../../components/Sidebar";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const AadhaarToPAN = () => {
  const [aadhaar, setAadhaar] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [commercial, setCommercial] = useState(null);

  const validateAndProceed = async () => {
    if (!aadhaar || aadhaar.length !== 12) {
      Swal.fire("Invalid!", "Enter a valid 12-digit Aadhaar number", "warning");
      return;
    }
    fetchCommercial();
  };

  const fetchCommercial = async () => {
    setLoading(true);
    try {
      const result = await UtiPanCardService.panFindFetchCommercial();

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      setCommercial(result.data.data);
      setShowPayment(true);
    } catch (err) {
      Swal.fire("Oops!", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const proceedPayment = async () => {
    setShowPayment(false);
    setLoading(true);

    try {
      const result = await UtiPanCardService.panFindTransaction(aadhaar);

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      setResponseData(result.data.data);
    } catch (err) {
      Swal.fire("Oops!", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="mt-3">
      {loading && <LoadingScreen />}

      <Row>
        <SideBar />
        <Col md={9}>
          <Card className="shadow-sm p-3">
            {/* HEADER WITH REPORT BUTTON */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4>Aadhaar to PAN</h4>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() =>
                  (window.location.href = "/aadhaar-to-pan/report")
                }
              >
                Aadhaar to PAN Report
              </Button>
            </div>

            {/* INFO TEXT */}
            <p className="text-center text-muted">
              On this page, you can retrieve your lost PAN number using your
              Aadhaar number.
            </p>

            {/* CHARGES DISPLAY */}
            {commercial && (
              <div className="alert alert-info text-center py-2">
                Service Charges: ₹{commercial.charges} | Payable Amount: ₹
                {commercial.payable_amount}
              </div>
            )}

            <Row className="mt-3">
              <Col md={8}>
                <Form.Group>
                  <Form.Label>Aadhaar Number</Form.Label>
                  <Form.Control
                    maxLength={12}
                    placeholder="Enter Aadhaar Number"
                    value={aadhaar}
                    disabled={responseData}
                    onChange={(e) => setAadhaar(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex align-items-end">
                <Button
                  className="w-100"
                  onClick={validateAndProceed}
                  disabled={loading || responseData}
                >
                  {responseData ? "Completed" : "Submit"}
                </Button>
              </Col>
            </Row>

            {/* SUCCESS RESULT */}
            {responseData && (
              <div className="mt-4 text-center">
                <div style={{ fontSize: "50px", color: "green" }}>✅</div>

                <h5 className="text-success mt-4">Transaction Successful</h5>

                <p className="text-muted">
                  Copy your PAN number. Later, you can retrieve it from the
                  Aadhaar to PAN report page.
                </p>

                <Table bordered className="mt-3">
                  <tbody>
                    <tr>
                      <th>PAN Number</th>
                      <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                        {responseData.pan}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
          </Card>
        </Col>
      </Row>

      {/* PAYMENT CONFIRM DIALOG */}
      <Modal show={showPayment} onHide={() => setShowPayment(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <b>Service:</b> Aadhaar to PAN
          </p>
          <p>
            <b>Charges:</b> ₹{commercial?.charges}
          </p>
          <p>
            <b>Payable Amount:</b> ₹{commercial?.payable_amount}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPayment(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={proceedPayment}>
            Proceed to Payment
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AadhaarToPAN;
